<div fxLayout="row">
    <chip-collection *ngIf="!hideChips" [chips]="chips" (click)="$event.stopPropagation()" aria-label="ChipCollection-NoteAndAttachment-AdvancedComponents">
    </chip-collection>

    <command-menu *ngIf="hasCommands" [commands]="commands" icon="more_vert">
    </command-menu>
</div>